import React, { createContext, useContext, useEffect, useState } from "react";
import SockJS from "sockjs-client";
import { Stomp } from "@stomp/stompjs";
import { useSelector } from "react-redux";
import { endpoint } from "../../assets/api/endpoint";

// Create Context
const FindPlayerSocketContext = createContext();
export const useFindPlayerSocket = () => useContext(FindPlayerSocketContext);

const FindPlayerSocket = ({ children }) => {
    const { userAuthId } = useSelector((state) => state.loginInfo);
    const [socketFindPlayer, setSocketFindPlayer] = useState([]); 

    useEffect(() => {
        const socket = new SockJS(`${endpoint.BASE_URL_STAGING}public/ws`);
        const stompClient = Stomp.over(socket);

        stompClient.connect({}, () => {
            stompClient.subscribe("/game", (message) => {
                const payload = JSON.parse(message.body);
                setSocketFindPlayer((prev) => {
                    const updated = [...prev, payload];
                    return updated;
                });

            });
        });

        return () => {
            if (stompClient && stompClient.connected) {
                stompClient.disconnect();
            }
        };
    }, [userAuthId]);

    return (
        <FindPlayerSocketContext.Provider value={{ socketFindPlayer }}>
            {children}
        </FindPlayerSocketContext.Provider>
    );
};

export default  FindPlayerSocket;
